import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "provided-gradients" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_green_gradient = _resolveComponent("green-gradient")!
  const _component_red_gradient = _resolveComponent("red-gradient")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_green_gradient),
    _createVNode(_component_red_gradient)
  ]))
}